import * as React from "react";

export interface IIconTextButtonProps {
  icon: string;
  text?: string;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  tooltip?: string;
  id?: string;
}

const IconTextButton: React.SFC<IIconTextButtonProps> = ({
  icon,
  text,
  onClick,
  disabled,
  tooltip,
  id
}) => {
  return (
      <div
        className={[
            "IconTextButton",
            Boolean(disabled) && "disabled"
        ].filter(Boolean).join(" ")}
        onClick={!disabled ? onClick : undefined}
        title={tooltip}
        aria-label={tooltip}
        role="button"
        aria-disabled={disabled}
        data-testid={id}
      >
        <i data-testid={"icon-text-btn"} className={[icon, !!disabled && "disabledIcon"].join(' ')} />
        {text}
      </div>
  );
};

export default IconTextButton;
